import { setupPageDataEvent } from "@src/client/analytics/dataLayerEvents/setupPageDataEvent";
import { setupAudienceSegmentsEvent } from "./audienceSegmentsEvents";
import { setupWebVitalsEvent } from "./setupWebVitalsEvent";
import { setupCustomerIdentityEvent } from "./setupCustomerIdentityEvent";
import { setupCustomerLoyaltyDataEvent } from "./setupCustomerLoyaltyDataEvent";

export const setupPageLoadDataLayerEvents = () => {
  setupPageDataEvent();
  setupAudienceSegmentsEvent();
  setupWebVitalsEvent();
  setupCustomerIdentityEvent();
  setupCustomerLoyaltyDataEvent();
};
